import React, { Component } from "react";
import rjson from "relaxed-json";
import Dropzone from "react-dropzone";
import Toast from "react-bootstrap/Toast";
import Spinner from "react-bootstrap/Spinner";
import superagent from "superagent";
import "./admin.css";
import AdminSky from "./admin-sky";
import AdminCity from "./admin-city";
import AdminFileLoader from "./admin-fileLoader";

export default class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      fileName: null,
      fileKey: null,
      settings: null,
      toast: {
        isShow: false,
        alertType: null,
        message: null,
      },
      isLoading: false,
    };
  }

  onFileLoaded = (fileName, file, settings) => {
    this.setState({
      fileName,
      file,
      settings,
      fileKey: new Date().getTime().toString(),
    });
  };

  onFileException = (message) => {
    this.showError(message);
  };

  onSaveFile = (data) => {
    var fileName = this.state.fileName;
    var blob = new Blob([data], { type: "text/plain" });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      var elem = window.document.createElement("a");
      elem.href = window.URL.createObjectURL(blob);
      elem.download = fileName;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  };

  onSendFileToOrder = (data) => {
    this.setState({
      isLoading: true,
    });

    //var blob = new Blob([data], { type: "text/plain" });
    var file = new File([data], this.state.fileName, { type: "text/plain" });

    var formData = new FormData();
    formData.append("file", file);
    // formData.append("file", file);

    let that = this;
    superagent
      .post(`/api/Email/SendFileToOrder`)
      .send(formData)
      .end((error, result) => {
        that.setState({
          isLoading: false,
        });
        console.log(error);
        console.log(result);

        if (!error && result && result.text === "Ok") {
          that.showSuccess("Файл успешно отправлен");
        } else {
          var errorMessage = "";
          if (error) {
            if (error.message) {
              errorMessage += error.message;
            }
            if (error.response && error.response.text) {
              errorMessage += ": " + error.response.text;
            }
          } else {
            errorMessage += "Получен непверный ответ от сервера";
          }
          that.showError(errorMessage);
        }
      });
  };

  onCloseToast = () => {
    let toast = this.state.toast;
    this.setState({
      toast: {
        ...toast,
        isShow: false,
      },
    });
  };

  showError = (e) => {
    let toast = this.state.toast;
    this.setState({
      toast: {
        ...toast,
        isShow: true,
        alertType: "danger",
        message: e.toString(),
      },
    });
  };

  showSuccess = (e) => {
    let toast = this.state.toast;
    this.setState({
      toast: {
        ...toast,
        isShow: true,
        alertType: "success",
        message: e.toString(),
      },
    });
  };

  onSettingsChanged = (settings, callback) => {
    this.setState({ settings: { ...settings } }, callback);
  };

  render() {
    return (
      <div class="container ">
        <Toast
          show={this.state.toast.isShow}
          onClose={this.onCloseToast}
          delay={10000}
          autohide
          style={{
            position: "fixed",
            top: 10,
            right: 10,
            zIndex: 99999,
          }}
        >
          <Toast.Header>
            <strong className="mr-auto">Сообщение</strong>
            {/* <small>11 mins ago</small> */}
          </Toast.Header>
          <Toast.Body>
            <div
              class={
                "alert " +
                (this.state.toast.alertType
                  ? "alert-" + this.state.toast.alertType
                  : "")
              }
              role="alert"
            >
              {this.state.toast.message}
            </div>
          </Toast.Body>
        </Toast>
        <div class="card mt-3">
          <div class="card-body">
            <h3>Редактирование заказа</h3>
            <div class={"d-none " + (this.state.isLoading ? "overlay" : "")}>
              <Spinner animation="border" />
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <AdminFileLoader
                  onFileLoaded={this.onFileLoaded}
                  onFileException={this.onFileException}
                ></AdminFileLoader>
              </div>
            </div>
            {this.state.settings?.productType === "sky" ? (
              <AdminSky
                key={this.state.fileKey}
                settings={this.state.settings}
                onSettingsChanged={this.onSettingsChanged}
                onSaveFile={this.onSaveFile}
                onSendFileToOrder={this.onSendFileToOrder}
                onShowError={this.showError}
              ></AdminSky>
            ) : this.state.settings?.productType === "city" ? (
              <AdminCity
                key={this.state.fileKey}
                settings={this.state.settings}
                onSettingsChanged={this.onSettingsChanged}
                onSaveFile={this.onSaveFile}
                onSendFileToOrder={this.onSendFileToOrder}
                onShowError={this.showError}
              ></AdminCity>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
